import { Component, OnInit, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';

import { NominationListService } from '../../core/services/nomination-list.service';
import { Nomination } from '../../core/models/nomination';
import { PagedList } from '../../core/models/paged-list';
import { NominationDetailComponent } from '../nomination-detail/nomination-detail.component';

@Component({
  selector: 'app-nominations-card',
  templateUrl: './nominations-card.component.html',
  styleUrl: './nominations-card.component.scss',
})
export class NominationsCardComponent implements OnInit {
  pagedNominations: Signal<PagedList<Nomination> | undefined>;
  loading: Signal<boolean>;
  statuses: Signal<string[]>;

  search = new FormControl('', { nonNullable: true });
  statusFilter = new FormControl<string[]>([], { nonNullable: true });

  displayedColumns = ['type', 'nominee', 'position', 'lodged', 'decided', 'status', 'link'];

  constructor(private nominationListService: NominationListService, private dialog: MatDialog) {
    // Assigned in the constructor body (not as field initializers) because parameter-property
    // assignment for nominationListService happens here too, and field initializers run first.
    this.pagedNominations = toSignal(this.nominationListService.searchResult$);
    this.loading = toSignal(this.nominationListService.loading$, { initialValue: true });
    this.statuses = toSignal(this.nominationListService.knownStatuses$, { initialValue: [] });
  }

  ngOnInit(): void {
    this.search.valueChanges.subscribe((term) => (this.nominationListService.searchTerm = term));
    this.statusFilter.valueChanges.subscribe((statuses) => (this.nominationListService.statuses = statuses));

    // Kick off the initial, unfiltered search.
    this.nominationListService.searchTerm = '';
    this.nominationListService.statuses = [];
    this.nominationListService.pagingRequest = { pageNumber: 1, pageSize: 10 };
  }

  refresh(): void {
    this.nominationListService.refresh();
  }

  clearSearch(): void {
    this.search.setValue('');
  }

  handlePageEvent(e: PageEvent): void {
    this.nominationListService.pagingRequest = { pageSize: e.pageSize, pageNumber: e.pageIndex + 1 };
  }

  getStatusIcon(nomination: Nomination): string {
    switch (nomination.status) {
      case 'Granted':
        return 'check_circle';
      case 'Refused':
      case 'Withdrawn':
        return 'error_outline';
      default:
        return 'schedule';
    }
  }

  getStatusClass(nomination: Nomination): string {
    switch (nomination.status) {
      case 'Granted':
        return 'complete';
      case 'Refused':
      case 'Withdrawn':
        return 'error';
      default:
        return 'incomplete';
    }
  }

  openDetail(nomination: Nomination): void {
    this.dialog.open(NominationDetailComponent, {
      data: { nomination },
      panelClass: 'dialog-panel-medium',
      autoFocus: false,
    });
  }
}
